<template>
    <div>

        <div id="connectButton" v-show="!isOpen" @click="openScreen" @touchstart.stop="startMove()"
            @touchend.stop="endMove()" @touchmove.stop="doMove()">
            <img v-if="peerMeta && peerMeta.icons && peerMeta.icons[0]" :src="peerMeta.icons[0]">
            <img v-else src="@/assets/img/walletConnect.png" />

            <div class="notification-number">
                {{ totalNotifications }}
            </div>

        </div>

        <div v-if="isMoving" class="bottom-disconnect" :class="isDisconnectPlaced ? 'bottom-disconnect-on' : ''">
            <div class="x">X</div>
        </div>
    </div>
</template>


<script>
import TWEEN from '@tweenjs/tween.js'
export default {
    data() {
        return {
            mouseX: 0,
            mouseY: window.innerWidth / 2,
            isMoving: false,
            isDisconnectPlaced: false,


        }
    },

    methods: {
        startMove() {
            this.isMoving = true;
        },
        endMove() {
            this.isMoving = false;
            if(this.isDisconnectPlaced){
                this.$emit('disconnect')
            }
        },
        doMove() {
            if (this.isMoving) {
                let wrapper = document.getElementById('connectButton')
                let that = this
                wrapper.addEventListener("touchmove", function (e) {
                    let windowInnerWidth = window.innerWidth
                    let windowInnerHeight = window.innerHeight

                    if ((e.changedTouches[0].clientY) > 0 && (e.changedTouches[0].clientY + 50) < windowInnerHeight) {
                        that.mouseY = e.changedTouches[0].clientY - 22.5;

                    } else if ((e.changedTouches[0].clientY) < 22.5) {
                        that.mouseY = 0;

                    } else if ((e.changedTouches[0].clientY) > 0 && (e.changedTouches[0].clientY + 50) > windowInnerHeight) {
                        that.mouseY = windowInnerHeight - 50;

                    }
                    if ((e.changedTouches[0].clientX) > 0 && (e.changedTouches[0].clientX + 50) < windowInnerWidth) {
                        that.mouseX = e.changedTouches[0].clientX - 22.5;

                    } else if ((e.changedTouches[0].clientX) < 22.5) {
                        that.mouseX = 0;

                    } else if ((e.changedTouches[0].clientX) > 0 && (e.changedTouches[0].clientX + 50) > windowInnerWidth) {
                        that.mouseX = windowInnerWidth - 50;


                    }

                });
            }
        },

        tweenX(start, end) {
            let frameHandler
            let wrapper = document.getElementById('connectButton')

            // Handles updating the tween on each frame.
            const animate = function (currentTime) {
                TWEEN.update(currentTime)
                frameHandler = requestAnimationFrame(animate)
            }
            let tweeningValue = end
            const myTween = new TWEEN.Tween({ tweeningValue: start })
                .to({ tweeningValue: end }, 50)
                // Be careful to not to do too much here! It will slow down the app.
                .onUpdate(() => {
                    wrapper.style.left = tweeningValue + 'px'
                })
                .onComplete(() => {
                    // Make sure to clean up after ourselves.
                    cancelAnimationFrame(frameHandler)
                })
                // This actually starts the tween.
                .start()

            frameHandler = requestAnimationFrame(animate)
        },
        tweenY(start, end) {
            let frameHandler
            let wrapper = document.getElementById('connectButton')
            let windowInnerHeight = window.innerHeight

            // Handles updating the tween on each frame.
            const animate = function (currentTime) {
                TWEEN.update(currentTime)
                frameHandler = requestAnimationFrame(animate)
            }
            let tweeningValue = end
            const myTween = new TWEEN.Tween({ tweeningValue: start })
                .to({ tweeningValue: end }, 50)
                // Be careful to not to do too much here! It will slow down the app.
                .onUpdate(() => {

                    wrapper.style.top = tweeningValue + 'px'

                    if (windowInnerHeight - 130 < tweeningValue) {
                        this.isDisconnectPlaced = true
                    } else {

                        this.isDisconnectPlaced = false

                    }
                })
                .onComplete(() => {
                    // Make sure to clean up after ourselves.
                    cancelAnimationFrame(frameHandler)
                })
                // This actually starts the tween.
                .start()

            frameHandler = requestAnimationFrame(animate)
        },
        openScreen() {

            this.$emit('openScreen', true)


        }


    },

    watch: {
        mouseX(newVal, oldVal) {
            this.tweenX(oldVal, newVal)


        },
        mouseY(newVal, oldVal) {

            this.tweenY(oldVal, newVal)


        },

    },

    props: {
        connected: {
            type: Boolean,
            default: false
        },
        isOpen: {
            type: Boolean,
        },

        totalNotifications: {
            type: [String, Number]
        },
        peerMeta: {
            type: Object
        }
    },
    components: {

    },
    mounted() {


    },

    computed: {

    }
}
</script>

<style lang="scss" scoped>
#connectButton {
    display: flex;
    position: fixed;
    justify-content: center;
    align-items: center;
    top: 50%;
    left: 0;
    z-index: 55;
    width: 45px;
    height: 45px;
    background: white;
    border-radius: 50%;
    box-shadow: 0 5px 10px 2px rgba(0, 0, 0, 0.2);
    animation: 0.5s ease scaleIn;
    touch-action: none;

    img {
        width: 45px;
        height: 45px;
        object-fit: cover;
    }

    .notification-number {
        position: absolute;
        top: 0;
        right: 0;

        background: rgb(207, 207, 207);
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        color: white;

    }
}

.bottom-disconnect {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    height: 130px;
    width: 100%;
    background: rgba(0, 0, 0, 0.2);
    z-index: 6;

    justify-content: center;
    align-items: center;
    box-shadow: rgba(0, 0, 0, 0.2) 0 0 25px 25px;
transition: 0.3s all ease;
    .x {
        border: 3px solid rgb(50, 50, 50);
        display: flex;
        width: 40px;
        height: 40px;
        color: rgb(50, 50, 50);
        font-size: 20px;
        font-weight: 800;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
opacity: 0.7;

    }
}

.bottom-disconnect-on {
    .x {
        box-shadow: rgba(0, 0, 0, 0.2) 0 0 5px 5px;
        text-shadow: rgba(0, 0, 0, 0.5) 0 0 5px;

transition: 0.3s all ease;

    }
}

@keyframes scaleIn {
    0% {
        transform: scale(0%);

    }

    100% {
        transform: scale(100%);

    }
}


.v-enter-active,
.v-leave-active {
    transition: all 1s ease;
}

.v-enter-from,
.v-leave-to {
    transform: translateY(150%);
}
</style>